import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CompetencyData } from "src/app/Models/competencyModel.model";
import { Router } from "@angular/router";
import { SharedcompetencyService } from "src/app/services/sharedcompetency.service";
import { AuthServiceService } from "src/app/services/auth-service.service";
import { GsdRoles } from "src/app/enums/gsdRoles.enum";
import { CompetenciesService } from "../../competencies.service";
import { OthersService } from "../../others/othersDataService";
import { map, switchMap } from "rxjs/operators";
import { Subscription, forkJoin, of } from "rxjs";
import { SharedSkillService } from "src/app/views/skill-repository/shared-skill.service";

@Component({
  selector: 'app-sub-competency-page',
  templateUrl: './sub-competency-page.component.html',
  styleUrls: ['./sub-competency-page.component.css']
})
export class SubCompetencyPageComponent implements OnInit {
  compId: any;
  role: string;
  adminRole: number = 0;
  titlesubcomp: string;
  public subCompetencies: any;
  public data: any;
  public gridData: any;
  public competencyData: CompetencyData = new CompetencyData();
  public loader: boolean = false;
  public titlesubcompetency: any;
  public titlesubcompetencyId: any;
  public randomText: string = `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`;
  constructor(
    private _service: CompetenciesService,
    private _router: Router,
    private _sharedService: SharedcompetencyService,
    private auth: AuthServiceService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private otherService: OthersService,
    private sharedSkillService: SharedSkillService,
  ) { }

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    method: {},
    speed: 300,
    focusOnSelect: false,
    swipe: true,
    centerPadding: "25px",
    infinite: true,
    responsive: [
      {
        breakpoint: 1930,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: false,
          swipe: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true,

        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true,

        },
      },

      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true,

        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,

        },
      },
    ],
    nextArrow: '<button class="slick-next">Next</button> ',
    prevArrow: '<button class="slick-prev">Previous</button>',
  };
  compName: any
  subcomp: any
  unCheckedSubscription: Subscription;
  private pagenavigationSubscription: Subscription;
  CheckedStatusSubscription: Subscription
  competencyId: any
  subCompetencyId: any
  competencyname
  public subcomptitle: string;
  ngOnInit() {

    if (this.competencyId == null) {
      this.competencyId = sessionStorage.getItem("compId")
    }

    if (this.competencyname == null) {
      this.competencyname = sessionStorage.getItem("compTitle")
    }
    this.role = this.auth.getRole();
    if (this.role.includes(GsdRoles.SuperAdmin)) {
      this.adminRole = 1;
    }

    //this.fetchCompetencies();
  }


  opensubcompetencypage(comp, value) {
    this._service.setProfileStatus(this.competencyId)
    this._service.setCompetencyName(this.competencyname)
    this._service.setsubcompname({ name: comp.titlesubcomp, id: comp.titlesubcompid })
    this.otherService.updateName(comp.titlesubcomp);
    this.otherService.updateId(comp.titlesubcompid)
    this.titlesubcompetencyId = comp.titlesubcompid
    this.titlesubcompetency = comp.titlesubcomp.split(' ').join('')
    sessionStorage.setItem("SubcompTitle", this.titlesubcompetency);
    sessionStorage.setItem("SubcompId", this.titlesubcompetencyId);
    this.titlesubcompetency = this.titlesubcompetency.replace(/\//g, '');
    this.titlesubcompetency = this.titlesubcompetency.split(' ').join('')
    this.router.navigate([`Home/CMF Portal/${this.competencyname}/${this.titlesubcompetency}`])
  }

  dataWithCount = [];
  noHeader: any;
  loading: boolean = false;
  searchText: string = "";

  getImageSrc(name) {
    switch (name) {
      case "Java":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Microsoft":
        return "../../../assets/images/subcompetencies/microsofticon.png";
      case "DevOps":
        return "../../../assets/images/subcompetencies/devopsicon.png";
      case "Mobile Application":
        return "../../../assets/images/subcompetencies/mobile_app.png";
      case "OpenSource Technologies":
        return "../../../assets/images/subcompetencies/opensourcetech.jpg";
      case "Product Management":
        return "../../../assets/images/subcompetencies/product_management.jpg";
      case "Enterprise Content Management":
        return "../../../assets/images/subcompetencies/enterprise_content_management.jpg";
      case "Quality Engineering":
        return "../../../assets/images/subcompetencies/quality_control.jpg";
      case "UI and UX":
        return "../../../assets/images/subcompetencies/ui_ux.jpg";
      case "Business Analyst":
        return "../../../assets/images/subcompetencies/business_analyst.jpg";
      case "BigData/Data Analytics":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Cloud Data Engineering":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Data science/Predictive modeling":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Data Visualization/BI":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "DataOps":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "IPA - HyperAutomation":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "RPA":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Cloud Advisory":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Cloud Digital Workplace Services":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "CloudOps":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Threat Detection and Response":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Salesforce":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Mulesoft":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "IOT":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "MSDynamic 365":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Help Desk Support":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Network Support":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "InfraOps":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Program Management":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Program Coordinators":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Agile Transformation":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Project Management":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Resource Management":
        return "../../../assets/images/subcompetencies/javaiconde.png";
      case "Operations Management":
        return "../../../assets/images/subcompetencies/javaiconde.png";
    }
  }

  subcompe: any
  titlesubcompid: any
  subcompetencyCountMap = {}
  count = []
  fetchCompetencies() {

    this.loading = true;
    this.dataWithCount = [];

    this._service.getSubCompetenciesForDropDowns(this.competencyId).pipe(
      switchMap((response) => {
        const result = response.data;
        const countCache = {};
        const countObservables = result.map((res) => {
          const finalObj: any = {};
          finalObj.titlesubcomp = res.name;
          finalObj.titlesubcompid = res.id
          sessionStorage.setItem("titlesubcompname", finalObj.titlesubcomp)
          sessionStorage.setItem("titlesubcompid", finalObj.titlesubcompid)
          finalObj.competencyName = this.competencyname;
          if (countCache[finalObj.titlesubcomp]) {
            finalObj.count = countCache[finalObj.titlesubcomp];
            return of(finalObj);
          } else {
            return this._service.GetResourceCount(this.competencyId, finalObj.titlesubcomp).pipe(
              map((countResponse) => {
                finalObj.count = countResponse.data.totalCount;
                countCache[finalObj.titlesubcomp] = finalObj.count;
                return finalObj;
              })
            );
          }
        });

        return forkJoin(countObservables);
      })
    ).subscribe(
      (dataWithCount) => {
        this.dataWithCount = dataWithCount;
        this.loading = false;
      },
      (error) => {
        this.dataWithCount = [];
        this.cd.detectChanges();
      }
    );
  }
}